import React from 'react';

import { Column } from '@tanstack/react-table';

import classes from 'components/common/Tables/TableV8/components/Header/components/Filter/Filter.module.scss';

export const Filter = ({ column }: { column: Column<any, unknown> }) => {
    const columnFilterValue = column.getFilterValue();

    return (
        <DebouncedInput
            className={classes.filterInput}
            onChange={(value) => column.setFilterValue(value)}
            placeholder={column.columnDef.meta?.filterPlaceholder || `Search...`}
            type={'text'}
            value={(columnFilterValue ?? '') as string}
        />
    );
};

// A typical debounced input react component
const DebouncedInput = ({
    value: initialValue,
    onChange,
    debounce = 500,
    ...props
}: {
    value: string | number;
    onChange: (value: string | number) => void;
    debounce?: number;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'>) => {
    const [value, setValue] = React.useState(initialValue);

    React.useEffect(() => {
        setValue(initialValue);
    }, [initialValue]);

    React.useEffect(() => {
        const timeout = setTimeout(() => {
            onChange(value);
        }, debounce);

        return () => clearTimeout(timeout);
    }, [value]);

    return <input {...props} value={value} onChange={(e) => setValue(e.target.value)} />;
};
